<template>
  <div class="group relative">
    <Popover v-slot="{ open }">
      <PopoverButton as="div">
        <slot v-bind="{ open }" />
      </PopoverButton>

      <PopoverPanel
        v-if="authStore.userContext"
        static
        class="absolute right-0 top-full hidden max-w-52 rounded-xl bg-white p-4 shadow-xl focus:outline-none group-hover:grid"
      >
        <div class="mb-3 flex justify-between">
          <span class="text-sm">
            <IntlMsg v-bind="{ k: 'account.balance' }" />:
          </span>
          <MoneyWrap
            v-bind="{ number: authStore.userContext?.balance }"
            class="text-lg font-semibold text-blue-700"
          />
        </div>

        <AppLink
          :to="authStore.userContext.balanceLink + '#balance'"
          class="c-btn flex w-full items-center gap-1.5 rounded-lg bg-gray-100 p-2 text-lg text-gray-900 hover:bg-gray-250"
        >
          <PlusIcon class="h-5 w-5 stroke-2" />
          <IntlMsg v-bind="{ k: 'account.top-up' }" />
        </AppLink>

        <div class="-mx-1.5 my-4 h-0.5 bg-blue-50" />

        <nav class="flex flex-col gap-0.5">
          <AppLink
            v-if="authStore.userContext.is_staff"
            v-bind="{ to: '/admin/' }"
            class="w-full whitespace-nowrap px-2 py-1 text-left text-lg leading-6 text-gray-500 transition-colors hover:text-blue-700"
          >
            <IntlMsg v-bind="{ k: 'menu.admin-panel' }" />
          </AppLink>
          <AppLink
            v-if="authStore.userContext.is_staff"
            v-bind="{ to: '/my2/' }"
            class="flex w-full items-center justify-between gap-2 whitespace-nowrap px-2 py-1 text-left text-lg leading-6 text-gray-500 transition-colors hover:text-blue-700"
          >
            Dashboard v2
            <span
              class="rounded-full border border-amber-300 bg-amber-50 px-2 text-xs leading-4 text-amber-950"
              >test</span
            >
          </AppLink>
          <AppLink
            v-for="(item, i) in authStore.navItems"
            :key="i"
            v-bind="{ to: item.url }"
            class="w-full whitespace-nowrap px-2 py-1 text-left text-lg leading-6 text-gray-500 transition-colors hover:text-blue-700"
          >
            {{ item.text }}
          </AppLink>
        </nav>
      </PopoverPanel>
    </Popover>
  </div>
</template>

<script lang="ts" setup>
import { PlusIcon } from '@heroicons/vue/24/outline'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import { IntlMsg, MoneyWrap } from '/@shared/app'
import { AppLink } from '/@app'

import { useAuthStore } from '/@/stores'

const authStore = useAuthStore()
</script>
